import React from "react";
import EpicXLogo from "../assets/img/Epic-x-logo-white.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <div
        className="container-fluid footer py-5 wow fadeIn"
        data-wow-delay="0.2s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-xl-12">
              <div className="mb-5">
                <div className="row g-4">
                  {/* Logo and Social Links */}
                  <div className="col-md-6 col-lg-6 col-xl-4">
                    <div className="footer-item">
                      <Link to="/" className="p-0">
                        <img
                          src={EpicXLogo}
                          className="footer-logo"
                          alt="Logo"
                        />
                      </Link>
                      <p className="text-white mb-4 font-size-p">
                        Epic-X specializes in custom e-commerce development,
                        offering secure payment gateways, seamless API
                        integration, and 24/7 post-launch support to enhance
                        online businesses.
                      </p>
                      <div className="footer-btn d-flex">
                        <Link
                          className="btn-epic-x btn-md-square rounded-circle me-3"
                          // href="https://www.facebook.com/yourpage"
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Facebook"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </Link>
                        <Link
                          className="btn-epic-x btn-md-square rounded-circle me-3"
                          // href="https://www.facebook.com/yourpage"
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Twitter"
                        >
                          <i className="fab fa-twitter"></i>
                        </Link>
                        <Link
                          className="btn-epic-x btn-md-square rounded-circle me-3"
                          // href="https://www.facebook.com/yourpage"
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </Link>
                        <Link
                          className="btn-epic-x btn-md-square rounded-circle me-0"
                          // href="https://www.facebook.com/yourpage"
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="LinkedIn"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* Useful Links */}
                  <div className="col-md-6 col-lg-6 col-xl-2">
                    <div className="footer-item">
                      <h4 className="text-white mb-4">Useful Links</h4>
                      <Link to="/About-Us">
                        <i className="fas fa-angle-right me-2"></i> About Us
                      </Link>
                      <Link to="/services">
                        <i className="fas fa-angle-right me-2"></i> Services
                      </Link>
                      <Link to="/product/pricing">
                        <i className="fas fa-angle-right me-2"></i> Pricing
                      </Link>
                      <Link to="/contact-us">
                        <i className="fas fa-angle-right me-2"></i> Contact
                      </Link>
                      <Link to="#">
                        <i className="fas fa-angle-right me-2"></i> Careers
                      </Link>
                      <Link to="/ai-driven/post-launch-support">
                        <i className="fas fa-angle-right me-2"></i> Support
                      </Link>
                      <Link to="/PrivacyPolicy">
                      <i className="fas fa-angle-right me-2"></i> Privacy Policy
                      </Link>
                    </div>
                  </div>

                  {/* Products */}
                  <div className="col-md-6 col-lg-6 col-xl-2">
                    <div className="footer-item">
                      <h4 className="text-white mb-4">Products</h4>
                      <Link to="/product/B2B">
                        <i className="fas fa-angle-right me-2"></i> B2B -
                        Ecommerce
                      </Link>
                      <Link to="/product/B2C">
                        <i className="fas fa-angle-right me-2"></i> B2C -
                        Ecommerce
                      </Link>
                      <Link to="/product/Email">
                        <i className="fas fa-angle-right me-2"></i> Email
                        Campaign
                      </Link>
                      <Link to="/product/popup">
                        <i className="fas fa-angle-right me-2"></i> Popup
                        Builder
                      </Link>
                      <Link to="/product/chat">
                        <i className="fas fa-angle-right me-2"></i> AI Chatbot
                      </Link>
                    </div>
                  </div>

                  {/* Office Locations */}
                  <div className="col-md-6 col-xl-4">
                    <div className="footer-item">
                      <div className="d-flex mb-3">
                        <div className="btn-xl-square bg-primary text-white rounded p-4 me-4">
                          <i className="fas fa-map-marker-alt fa-2x"></i>
                        </div>
                        <div>
                          <h4 className="text-white">Registered Address</h4>
                          <p className="mb-0 font-size-p">
                            267/2, Kamaraj Nager Senthamangalam Road,
                            Namakkal, Tamil Nadu, 637001.
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="btn-xl-square bg-primary text-white rounded p-4 me-4">
                          <i className="fas fa-map-marker-alt fa-2x"></i>
                        </div>
                        <div>
                          <h4 className="text-white">Office Address</h4>
                          <p className="mb-0 font-size-p">
                            1274, RSB Towers, Mettupalayam Rd, 
                            Coimbatore, Tamilnadu 641043.
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="btn-xl-square bg-primary text-white rounded p-4 me-4">
                          <i className="fas fa-envelope fa-2x"></i>
                        </div>
                        <div>
                          <h4 className="text-white">Mail Us</h4>
                          <p className="mb-0 font-size-p">
                            techsupport@epic-x.io
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Copyright Start */}
      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-12 text-center text-md-center mb-md-0">
              <span className="text-body">
                <Link to="#" className="text-white">
                  <i className="fas fa-copyright text-white me-2"></i>Copyright
                  2025{" "}
                  <strong>
                    <span>Epic-X Bharat Private Limited</span>
                  </strong>
                </Link>
                , All right reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Copyright End */}
    </>
  );
};

export default Footer;
